import { render, staticRenderFns } from "./price-setup.vue?vue&type=template&id=108b283e&"
import script from "./price-setup.vue?vue&type=script&lang=js&"
export * from "./price-setup.vue?vue&type=script&lang=js&"
import style0 from "./price-setup.vue?vue&type=style&index=0&id=108b283e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports